import styled from 'styled-components/macro'
import Illustration from './assets/ilustrations.png'
import IllustrationMobile1 from './assets/ilustrations-mobile1.png'
import IllustrationMobile2 from './assets/ilustrations-mobile2.png'
import { mq } from 'styles/mq'

export const Lists = styled.div`
  margin: 5rem 2rem;
  background: url('${IllustrationMobile1}') 0 0 / 100% auto no-repeat,
    url('${IllustrationMobile2}') 0 100% / 100% auto no-repeat;

  ${mq.medium} {
    display: flex;
    gap: 3rem;
    width: auto;
    background: url('${Illustration}') 0 0 / 95% auto no-repeat;
  }
`

export const Col = styled.div`
  ${mq.smallOnly} {
    width: max-content;
    text-align: center;

    &:last-child {
      margin-left: auto;
    }
  }

  ${mq.medium} {
    flex-grow: 1;
  }
`

export const List = styled.dl`
  &,
  dt,
  dd {
    margin: 0;
  }

  dt,
  dd {
    display: inline;
  }

  dt {
    font-weight: bold;
  }

  > div {
    margin: 2.6rem 0;
  }

  ${mq.smallOnly} {
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 2rem 0;
    }
  }

  ${mq.medium} {
    dd::before {
      content: ' – ';
    }
  }
`

export const ListTitle = styled.h4`
  all: unset;
`
